import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback({ module = "presently" }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUserFromCallback } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!sessionId) {
        navigate(`/${module}/login`, { replace: true });
        return;
      }
      try {
        const { data } = await api.post(
          `/auth/google?module=${encodeURIComponent(module)}`,
          null,
          { headers: { "X-Session-ID": sessionId } }
        );
        setUserFromCallback(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(`/${module}`, { replace: true });
      } catch (e) {
        toast.error(formatApiError(e));
        navigate(`/${module}/login`, { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="flex items-center gap-3 text-muted-foreground">
        <Loader2 className="h-5 w-5 animate-spin" />
        <span className="font-mono-mini text-sm">Signing you in…</span>
      </div>
    </div>
  );
}
